import BasePolicy from '@/policies/BasePolicy.js';

export default class CourseTemplatePolicy extends BasePolicy {
    viewAny(user) {
        return (
            user.hasPermissionTo('view all course templates') || user.hasGroupPermissionTo('view all course templates')
        );
    }

    view(user, courseTemplate) {
        return user.hasPermissionViaCourseTo(courseTemplate, 'view a course template');
    }

    create(user, groupIds) {
        if (!groupIds) {
            return user.hasPermissionTo('create a course template');
        }

        return user.hasGroupPermissionTo('create a course template');
    }

    update(user, courseTemplate) {
        return user.hasPermissionViaCourseTo(courseTemplate, 'edit a course template');
    }

    delete(user, courseTemplate) {
        return user.hasPermissionViaCourseTo(courseTemplate, 'delete a course template');
    }

    archive(user, courseTemplate) {
        return user.hasPermissionViaCourseTo(courseTemplate, 'archive a course template');
    }
}
